export default {
      id: "pause-usage",
      viewBox: "0 0 11 12",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#pause",
      toString: function () {
        return this.url;
      }
    }